import { z } from "zod";
import { machineTypeSchema } from "@packsize/schemas/machines";

export const machineInfoSchema = z.object({
	machineId: z.string(),
	machineType: machineTypeSchema,
});

export type MachineInfo = z.infer<typeof machineInfoSchema>;

export type MachineFaultType = "Warning" | "Error";

export interface MachineFaultDisplay {
	readonly machineId: string;
	readonly title: string;
	readonly resolution?: string;
	readonly image?: string;
	readonly fallbackImage?: string;
	readonly type: MachineFaultType;
}

export type OnErrorsChangedCallback = (machineId: string, errors: MachineFaultDisplay[]) => void;
export type OnWarningsChangedCallback = (machineId: string, warnings: MachineFaultDisplay[]) => void;

export type ErrorsAndWarningsProps = {
	machines: MachineInfo[];
	onErrorsChanged: OnErrorsChangedCallback;
	onWarningsChanged?: OnWarningsChangedCallback;
};
